import { Component } from 'react';
import * as PropTypes from 'prop-types';
import Upload from 'antd/lib/upload';
import { PlusOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

import { status } from '../services/constants';

export const filePropTypes = {
    uid: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    status: PropTypes.oneOf(Object.values(status)),
    url: PropTypes.string,
    thumbUrl: PropTypes.string,
};

export const fileShape = PropTypes.shape(filePropTypes);

class Uploader extends Component {
    static propTypes = {
        fileList: PropTypes.arrayOf(fileShape),
        initialFiles: PropTypes.arrayOf(fileShape),
        name: PropTypes.string.isRequired,
        handleRequest: PropTypes.func,
        handleRemove: PropTypes.func,
        create: PropTypes.func.isRequired,
        remove: PropTypes.func.isRequired,
        enableReinitialize: PropTypes.bool,
    };

    static defaultProps = {
        fileList: [],
        initialFiles: [],
        handleRequest: () => {},
        handleRemove: () => {},
        enableReinitialize: false,
    };

    componentDidMount() {
        this.props.create(this.props.name, this.props.initialFiles);
    }

    componentDidUpdate(props) {
        if (this.props.initialFiles !== props.initialFiles && this.props.enableReinitialize) {
            this.props.create(this.props.name, this.props.initialFiles);
        }
    }

    componentWillUnmount() {
        this.props.remove(this.props.name);
    }

    render() {
        const { fileList, handleRemove, handleRequest } = this.props;
        const props = {
            fileList,
            customRequest: handleRequest,
            onRemove: handleRemove,
            listType: 'picture-card',
        };

        return (
            <Upload {...props}>
                <PlusOutlined />
                <div className="ant-upload-text">
                    <FormattedMessage id="uploader.button" />
                </div>
            </Upload>
        );
    }
}

export default Uploader;
